
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const Search = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__background">
          <rect width="25" height="25"></rect>
        </g>
        <g className="fe_c_icon__icon fe_c_icon__icon--primary">
          <path d="M22.8,21.7,17,16A8,8,0,0,0,10.8,2.8,8.5,8.5,0,0,0,5.1,5.1a8.1,8.1,0,0,0,5.7,13.8A7.8,7.8,0,0,0,16,17l5.7,5.8Zm-12-4.3a6.6,6.6,0,0,1-4.6-1.9,6.8,6.8,0,0,1-1.9-4.7,6.5,6.5,0,0,1,6.5-6.5,6.8,6.8,0,0,1,4.7,1.9,6.7,6.7,0,0,1,0,9.3A6.8,6.8,0,0,1,10.8,17.4Z"></path>
        </g>
      </g>
    </IconBase>);
};

Search.defaultProps = {
  title: 'Search',
};

export default Search;
